import * as S from "./styles.ts";
import { Button, H5, P } from "@template/components";

interface IDocumentationCardProps {
  title: string;
  description: string;
  itemKey: string;
  pageKey: string;
  context: "domain-names" | "voip";
}

export const DocumentationCard = ({
  title,
  description,
  itemKey,
  pageKey,
  context,
}: IDocumentationCardProps) => {
  return (
    <S.DocumentationCardContainer>
      <S.TextContainer>
        <H5>{title}</H5>
        <P>{description}</P>
      </S.TextContainer>
      <Button
        variant="outline"
        size="md"
        navigation={{
          href: `/${context}/api-docs/${itemKey}/${pageKey}`,
        }}
      >
        Learn More
      </Button>
    </S.DocumentationCardContainer>
  );
};
